// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';

import Toggle from './Toggle';

import Styles from './collapsible.module.scss';

type colors = 'alabaster' | 'black' | 'doveGray' | 'white' | 'nobel' | 'doveGray' | 'denimBlue';

interface PropsType {
    chevronColor: colors;
    children: JSX.Element;
    colorOnClose: colors;
    colorOnOpen: colors;
    header: JSX.Element;
    className?: string;
    isOpen?: boolean;
    tableName?: string;
}

export default function Collapsible(props: PropsType) {
    const [isOpen, setIsOpen] = React.useState(props.isOpen || false);

    function handleToggle () {
        setIsOpen(!isOpen);
    }

    return (
        <div className={appendClassName(props.className)}>
            <Toggle tableName={props.tableName} handleToggle={handleToggle} {...props} isOpen={isOpen} >
                {props.header}
            </Toggle>
            {renderBody(props.children, isOpen)}
        </div>
    );
}

function appendClassName(className: string = '') {
    return `${Styles.section} ${className}`;
}

function renderBody(children: any, isOpen: boolean) {
    if (!isOpen) {
        return null;
    }

    return (
        <div className={Styles.body}>
            {children}
        </div>
    );
}
